import { MecordColors } from "Constants/Color";
import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";

interface ProductDetailsTableProps {
  products: any[];
  formik: any;
  onRemarkChange?: (index: number, remark: string) => void;
}

const ProductDetailsTable: React.FC<ProductDetailsTableProps> = ({
  products,
  onRemarkChange,
  formik,
}) => {
  const [remarks, setRemarks] = useState<string[]>([]);

  useEffect(() => {
    // Initialize remarks from products
    const initialRemarks = products.map((prod: any) => prod?.remark || "");
    setRemarks(initialRemarks);
  }, [products]);

  const handleRemarkChange = (index: number, value: string) => {
    const updatedRemarks = [...remarks];
    updatedRemarks[index] = value;
    setRemarks(updatedRemarks);

    if (onRemarkChange) {
      onRemarkChange(index, value);
    }
  };

  return (
    <div className="mb-4">
      <h6 className="fw-semibold mb-2" style={{ fontSize: "0.9rem" }}>
        Product Details
      </h6>
      <Table
        bordered={false}
        responsive
        style={{ borderCollapse: "collapse" }}
        className="align-middle"
      >
        <thead
          style={{
            backgroundColor: MecordColors?.LightGrayColor,
            color: "#000",
          }}
        >
          <tr>
            <th style={{ minWidth: "50px" }}>Sr.No</th>
            <th style={{ minWidth: "180px" }}>Product Name</th>
            <th style={{ minWidth: "180px" }}>Product Code</th>
            <th style={{ minWidth: "120px" }}>Order Quantity</th>
            <th style={{ minWidth: "100px" }}>Unit</th>
            <th style={{ minWidth: "180px" }}>Unit Price</th>
            <th style={{ minWidth: "180px" }}>Rate in Currency</th>
            <th style={{ minWidth: "180px" }}>Gross Value</th>
            <th style={{ minWidth: "130px" }}>GST%</th>
            <th style={{ minWidth: "130px" }}>CGST%</th>
            <th style={{ minWidth: "130px" }}>SGST%</th>
            <th style={{ minWidth: "130px" }}>IGST%</th>
            <th style={{ minWidth: "150px" }}>Total</th>
            <th style={{ minWidth: "400px" }}>Description</th>
            <th style={{ minWidth: "180px" }}>Remarks</th>
          </tr>
        </thead>

        <tbody>
          {products.length === 0 ? (
            <tr>
              <td
                colSpan={16}
                className="text-center py-4"
                style={{ color: "#6c757d" }}
              >
                No products found
              </td>
            </tr>
          ) : (
            products.map((prod: any, idx) => {
              return (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{prod?.product_name}</td>
                  <td>{prod?.product_code}</td>
                  <td>{prod?.order_quantity}</td>
                  <td>{prod?.unit_name}</td>
                  <td>{prod?.unit_price}</td>
                  <td>
                    {
                    // Number(formik?.values?.exchange_rate) === 1
                    //   ? "-" : 
                      formik?.values?.currency?.currency_symbol}{" "}
                    {
                    // Number(formik?.values?.exchange_rate) === 1
                    //   ? "-" : 
                      prod?.rate_in_currency}
                  </td>
                  <td>
                    {formik?.values?.currency?.currency_symbol}{" "}
                    {prod?.net_taxable_value}
                  </td>
                  <td>{prod?.gst_percent}</td>
                  <td>{prod?.cgst_percent}</td>
                  <td>{prod?.sgst_percent}</td>
                  <td>{prod?.igst_percent}</td>
                  <td>
                    {formik?.values?.currency?.currency_symbol} {prod?.total}
                  </td>
                  <td>{prod?.description || "-"}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={remarks[idx] || ""}
                      onChange={(e) => handleRemarkChange(idx, e.target.value)}
                      placeholder="Enter remark"
                      style={{
                        fontSize: "0.875rem",
                        padding: "0.25rem 0.5rem",
                        borderRadius: "0.25rem",
                        border: "1px solid #ced4da",
                      }}
                    />
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ProductDetailsTable;
